import { Collapse } from '../../../../components/Collapse'
import { Collapse as CollapseAntd } from 'antd'
import { Typography } from 'components/Typography'
import { Chips } from '../../../../components/Chips/Chips'
import { TableProcessing } from './Table'

const { Panel } = CollapseAntd

export const Item = ({ activeKey, onChange, item, callback }) => {
  return (
    <Collapse activeKey={activeKey} onChange={onChange} accordion={true}>
      <Panel
        key={item.uuid}
        header={
          <div className="row align-center gap-8">
            <Typography.Body1>{item.name}</Typography.Body1>
            {!!item.count_hs_without_value && (
              <Chips.Menu>{item.count_hs_without_value}</Chips.Menu>
            )}
          </div>
        }
      >
        <TableProcessing uuid={item.uuid} callback={callback} />
      </Panel>
    </Collapse>
  )
}
